<template>
  <div class="screen">
    <span>统计时间：</span>
    <el-select v-model="value" placeholder="请选择" size="small" style="width:100px">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>

    <el-date-picker v-model="selectDate" type="date" placeholder="选择日期" size="small" v-if="value==1"></el-date-picker>
    <el-date-picker v-model="selectWeek" type="week" format="yyyy 第 WW 周" placeholder="选择周" size="small" v-else-if="value==2"></el-date-picker>
    <el-date-picker v-model="selectMonth" type="month" placeholder="选择月" size="small" v-else-if="value==3"></el-date-picker>
    <span v-else-if="value == 4">{{ Insevenday }}</span>
    <span v-else>{{ nearlyOnemonth }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [
        {
          value: "1",
          label: "自然日"
        },
        {
          value: "2",
          label: "自然周"
        },
        {
          value: "3",
          label: "自然月"
        },
        {
          value: "4",
          label: "近7天"
        },
        {
          value: "5",
          label: "近30天"
        }
      ],
      value: "1",
      selectDate: "",
      selectWeek: "",
      selectMonth: "",
      Insevenday: this.Insevendays(),
      nearlyOnemonth: this.nearlyOnemonths()
    };
  },
  methods: {
    Insevendays() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      return `${this.setTime(start.getTime())}至${this.setTime(end.getTime())}`;
    },
    nearlyOnemonths() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      return `${this.setTime(start.getTime())}至${this.setTime(end.getTime())}`;
    },
    setTime(fmt) {
      const time = new Date(fmt);
      const Y = time.getFullYear();
      const M = (time.getMonth() + 1).toString().padStart(2, "0");
      const D = time
        .getDate()
        .toString()
        .padStart(2, "0");
      return `${Y}-${M}-${D}`;
    },
  }
};
</script>

<style lang="scss" scoped>
.screen {
  padding: 16px;
  background: #fff;
  margin-bottom: 14px;

  .el-select {
    margin-right: 14px;
  }
}
</style>
